import { LogLevel } from 'angular-auth-oidc-client';

export const environment = {
  production: true,
  apiEndpoint: 'https://start.efs-ag.com/v1',
  userApiEndpoint: 'https://api.efs-ag.services/v2',

  openIdConfig: {
    authority: 'https://auth.efs-ag.services',
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: 'https://start.efs-ag.com',
    postLoginRoute: '/',
    clientId: 'efs.start',
    scope: 'openid email profile',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 180,
    logLevel: LogLevel.Error,
    forbiddenRoute: '/unauthorized',
    unauthorizedRoute: '/unauthorized',
  },
};
